// src/pages/ViewProfilePage.jsx
import React, { useState, useEffect } from "react";
import {
  Container,
  Box,
  Typography,
  Avatar,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Divider,
  Paper,
  Button,
} from "@mui/material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField
} from "@mui/material";

import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";

function ViewProfilePage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [recentPosts, setRecentPosts] = useState([]);

  const currentUser = JSON.parse(localStorage.getItem("user")) || {};
  const [openMessageDialog, setOpenMessageDialog] = useState(false);
    const [inviteMessage, setInviteMessage] = useState("");


  useEffect(() => {
    if (id) {
      fetchUser(id);
      fetchPosts(id);
    }
  }, [id]);

  const fetchUser = async (uid) => {
    try {
      const res = await axios.get(`http://localhost:5000/users/${uid}`);
      if (res.data.user) {
        setUser(res.data.user);
      }
    } catch (err) {
      console.error("Error loading profile:", err);
    }
  };

  const fetchPosts = async (uid) => {
    try {
      const res = await axios.get(`http://localhost:5000/posts/user/${uid}`);
      setRecentPosts(res.data.posts || []);
    } catch (err) {
      console.error("Error loading posts:", err);
    }
  };



  if (!user)
    return (
      <Container sx={{ textAlign: "center", mt: 12 }}>
        <Typography color="error">User not found.</Typography>
      </Container>
    );

  return (
    <Container maxWidth="md" sx={{ mt: 6 }}>
      <Paper
        elevation={3}
        sx={{
          p: 4,
          borderRadius: 4,
          backgroundColor: "#FFFFFF",
          boxShadow: "0 4px 20px rgba(0,0,0,0.04)",
        }}
      >
        {/* HEADER */}
        <Box display="flex" alignItems="center" mb={4} gap={3}>
          <Avatar
            src={user.passport || ""}
            alt={user.firstName}
            sx={{
              width: 100,
              height: 100,
              border: "3px solid #16A34A",
              boxShadow: "0 2px 6px rgba(22,163,74,0.2)",
            }}
          />

          <Box flex={1}>
            <Typography variant="h5" fontWeight="bold">
              {user.firstName} {user.lastName}
            </Typography>

            <Typography variant="body1" color="text.secondary" sx={{ mt: 0.5 }}>
              {user.bio || "No bio yet."}
            </Typography>

            {/* Stats */}
            <Box display="flex" gap={6} mt={2}>
              <Box>
                <Typography variant="subtitle2" color="text.secondary">
                  LifePoints
                </Typography>
                <Typography variant="h6" fontWeight="700" color="#16A34A">
                  {user.points ?? 0}
                </Typography>
              </Box>

              <Box>
                <Typography variant="subtitle2" color="text.secondary">
                  Shoutouts
                </Typography>
                <Typography variant="h6" fontWeight="700" color="#F59E0B">
                  {user.shoutouts ?? 0}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* ⭐ ACTION BUTTONS */}
        <Box
          sx={{
            display: "flex",
            gap: 2,
            mb: 4,
            justifyContent: "flex-start",
          }}
        >
            <Button
            variant="contained"
            sx={{
                backgroundColor: "#16A34A",
                textTransform: "none",
                fontWeight: 600,
                px: 3,
                py: 1.2,
                "&:hover": { backgroundColor: "#15803D" },
            }}
            onClick={() => setOpenMessageDialog(true)}
            >
            ⚡ Request moment
            </Button>

        </Box>

        {/* HOBBIES */}
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {user.hobbies || "No hobbies added yet."}
        </Typography>

        <Divider sx={{ my: 3 }} />

        {/* RECENT MOMENTS */}
        <Typography variant="h6" fontWeight="600" sx={{ mb: 2 }}>
          Recent Moments
        </Typography>

        <Grid container spacing={2}>
          {recentPosts.length === 0 && (
            <Typography color="text.secondary" sx={{ ml: 1 }}>
              No recent moments yet.
            </Typography>
          )}

          {recentPosts.slice(0, 4).map((post) => (
            <Grid item xs={12} sm={6} key={post.id}>
              <Card
                sx={{
                  borderRadius: 3,
                  overflow: "hidden",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                }}
              >
                {post.media_path && (
                  <CardMedia
                    component="img"
                    height="180"
                    image={`http://localhost:5000/${post.media_path}`}
                    alt="moment"
                  />
                )}

                <CardContent>
                  <Typography
                    variant="subtitle2"
                    color="text.secondary"
                    sx={{ mb: 0.5 }}
                  >
                    {new Date(post.createdAt).toLocaleString([], {
                      dateStyle: "medium",
                      timeStyle: "short",
                    })}
                  </Typography>

                  <Typography variant="body1" fontWeight={500}>
                    {post.activity || post.notes || "Shared a moment"}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Paper>

      <Dialog open={openMessageDialog} onClose={() => setOpenMessageDialog(false)}>
  <DialogTitle>Send a Moment Request</DialogTitle>

  <DialogContent>
    <Typography sx={{ mb: 2 }}>
      Add an optional message to your moment request:
    </Typography>

    <TextField
      fullWidth
      multiline
      minRows={2}
      placeholder="Hey! Want to share a quick moment?"
      value={inviteMessage}
      onChange={(e) => setInviteMessage(e.target.value)}
    />
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setOpenMessageDialog(false)}>Cancel</Button>

    <Button
      variant="contained"
      sx={{ backgroundColor: "#16A34A" }}
      onClick={async () => {
        try {
                        if (currentUser.id === user.id) {
            alert("You cannot request a moment with yourself.");
            return;
            }

         await axios.post("http://localhost:5000/invitations", {


            senderId: currentUser.id,
            receiverId: user.id,
            message: inviteMessage.trim(),
          });

          setOpenMessageDialog(false);
          setInviteMessage("");

          alert("Moment request sent!");
          navigate("/dashboard?view=notifications");

        } catch (err) {
          alert("Failed to send request.");
        }
      }}
    >
      Send Request
    </Button>
  </DialogActions>
</Dialog>



    </Container>
  );
}

export default ViewProfilePage;
